'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _googleMapReact = require('google-map-react');

var _googleMapReact2 = _interopRequireDefault(_googleMapReact);

var _ = require('.');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DynamicMap = function (_Component) {
  (0, _inherits3.default)(DynamicMap, _Component);

  function DynamicMap() {
    (0, _classCallCheck3.default)(this, DynamicMap);
    return (0, _possibleConstructorReturn3.default)(this, (DynamicMap.__proto__ || (0, _getPrototypeOf2.default)(DynamicMap)).apply(this, arguments));
  }

  (0, _createClass3.default)(DynamicMap, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var defaultCenter = {
        lat: this.props.centerLat,
        lng: this.props.centerLng
      };

      var _props = this.props,
          events = _props.events,
          handleOnClick = _props.handleOnClick,
          marker = _props.marker,
          onCenterChange = _props.onCenterChange,
          initialZoom = _props.initialZoom;

      var Marker = function Marker(props) {
        return marker(props);
      };

      return _react2.default.createElement(
        _googleMapReact2.default,
        {
          defaultCenter: defaultCenter,
          defaultZoom: initialZoom,
          onChange: onCenterChange,
          style: { minHeight: '1px' } // The map does not always display without this
        },
        events.map(function (e) {
          return _react2.default.createElement(Marker, (0, _extends3.default)({ key: e.id, onClick: handleOnClick.bind(_this2, e.id) }, e));
        })
      );
    }
  }]);
  return DynamicMap;
}(_react.Component);

DynamicMap.propTypes = {
  /**
   * The starting latitude.
   */
  centerLat: _propTypes2.default.number.isRequired,
  /**
   * The starting longitude.
   */
  centerLng: _propTypes2.default.number.isRequired,
  /**
   * A list of events to render.
   */
  events: _propTypes2.default.array.isRequired,
  /**
   * Method called when clicking on a marker.
   */
  handleOnClick: _propTypes2.default.func,
  /**
   * A component or node to display as a marker.
   */
  marker: _propTypes2.default.func,
  /**
   * Method called when the map has moved.
   * It is recommended to fetch as far as the largest dimension
   * from the borders to ensure there are no gaps when dragging.
   */
  onCenterChange: _propTypes2.default.func,
  /**
   * The starting zoom.
   */
  initialZoom: _propTypes2.default.number.isRequired
};

DynamicMap.DefaultMarker = function () {
  return _react2.default.createElement(_.Icon, { name: 'pin' });
};

DynamicMap.defaultProps = {
  marker: DynamicMap.DefaultMarker
};
exports.default = DynamicMap;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/DynamicMap.js
// module id = 259
// module chunks = 0